import { isAccDetailId } from '@mypoz/shared';

import { LAST_TOP_UP_KEY } from '@/features/wallet/config.js';

/**
 * A plain top-up number from the address: letters, digits, `-` and `_`, at most 40 characters.
 * Anything else is treated as missing rather than looked for.
 */
export function isPlainOrderId(value: string | null | undefined): value is string {
  return typeof value === 'string' && /^[A-Za-z0-9_-]{1,40}$/.test(value);
}

/**
 * The saved record id, guarded: storage can be switched off or throw (private browsing). Only a
 * fallback for the result page; a missing one is never an error.
 */
export function readLastTopUp(): string | undefined {
  try {
    const value = sessionStorage.getItem(LAST_TOP_UP_KEY);
    return isAccDetailId(value) ? value : undefined;
  } catch {
    return undefined;
  }
}

export function saveLastTopUp(accdetailid: string): void {
  try {
    sessionStorage.setItem(LAST_TOP_UP_KEY, accdetailid);
  } catch {
    // Storage can be off; the result page reads the address first anyway.
  }
}

export function clearLastTopUp(): void {
  try {
    sessionStorage.removeItem(LAST_TOP_UP_KEY);
  } catch {
    // Nothing to clear.
  }
}
